// Venta / Utilización (ingreso) por Segmento — renta prorrateada al precio
// diario sobre los días que caen dentro del periodo, pivoteada por segmento ×
// CP/LP/Total. Incluye las rentas cubiertas con unidades subarrendadas, y
// reparte los días entre las dos unidades cuando la reserva cambió de auto.
import supabase from "../../../supabase-client";

const fmtMoney = (v) =>
  "$" + Math.round(Number(v) || 0).toLocaleString("es-MX");

export const revenueBySegmentReport = {
  id: "revenue-by-segment",
  title: "Venta Utilización",
  description: "Ingreso por días rentados dentro del periodo, prorrateado al precio diario, por segmento y sucursal. Incluye unidades subarrendadas.",
  category: "Finanzas",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  pivot: {
    rowKey: "segment",
    colKey: "branch",
    valueKey: "value",
    rowLabel: "Venta",
    rowOrder: ["Carga", "Pasajeros", "Sedanes"],
    colOrder: ["CP", "LP"],
    format: fmtMoney,
    exportType: "currency",
  },
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_revenue_segment", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
